const { GkifyThemeStyles, GkifyThemeScripts } = window;
class QuickView {
  constructor() {
    this.modal = new GkifyTheme.Modal();
    this.isOpen = false;

    addEventDelegate({
      selector: '.g-product-quickview-button',
      handler: (e, target) => {
        e.preventDefault();
        this.target = target;
        this.toggleLoading(this.target, true);
        const productHandle = target.dataset.productHandle;
        this.number = this.getScrollToTop();
        if (productHandle) this.fetchHtml(productHandle);
      },
    });

    // Quickview HTML is fetched and inserted after this script has loaded.
    // Bind on document in the capture phase so each newly opened modal works.
    document.addEventListener('click', (e) => this.handleDiscountCodeCopy(e), true);

    window.GkifyEvents.subscribe(GkifyTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) GkifyTheme.ProductQuickView.close();
    });
  }
  handleDiscountCodeCopy(e) {
    const btn = e.target.closest('.g-product-quickview .Product_copyBtn');
    if (!btn) return;

    e.preventDefault();
    const textEl = btn.closest('.Product_copy_L_PN')?.querySelector('.Product_copy_next');
    const textToCopy = textEl?.textContent?.trim();
    if (!textToCopy) return;

    const originalText = btn.textContent.trim();
    const successText = btn.dataset.copiedText || 'Copied';
    this.copyText(textToCopy)
      .then(() => {
        btn.textContent = successText;
        setTimeout(() => {
          btn.textContent = originalText;
        }, 2000);
      })
      .catch((err) => console.error('Copy failed:', err));
  }
  copyText(text) {
    if (navigator.clipboard) return navigator.clipboard.writeText(text);
    // Fallback for non-secure contexts where navigator.clipboard is unavailable
    return new Promise((resolve, reject) => {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy') ? resolve() : reject(new Error('Copy failed'));
      } catch (err) {
        reject(err);
      } finally {
        textarea.remove();
      }
    });
  }
  getScrollToTop() {
    let scrollDom = null;
    if (GkifyTheme.config.mqlMobile) {
      scrollDom = document.querySelector('.g-modal--content');
    } else {
      scrollDom = document.querySelector('.g-product-quickview--info');
    }
    return scrollDom && scrollDom.scrollTop;
  }
  scrollToTop() {
    let scrollDom = null;
    if (GkifyTheme.config.mqlMobile) {
      scrollDom = document.querySelector('.g-modal--content');
    } else {
      scrollDom = document.querySelector('.g-product-quickview--info');
    }
    scrollDom && (scrollDom.scrollTop = this.number || 0);
  }
  fetchHtml(productHandle) {
    loadAssetsNew([GkifyThemeStyles.product, GkifyThemeStyles.productInventory], 'quick-view-assets');
    fetchSection('product-quickview', { url: `${window.GkifySettings.base_url}products/${productHandle}` })
      .then((html) => {
        this.modalContent = html.querySelector('.g-product-quickview');
        const firstModel = html.querySelector('product-model');
        this.mediaGallery = this.modalContent.querySelector('media-gallery');
        loadPaypalScript();
        loadAssetsNew(
          [GkifyThemeScripts.productMedia, GkifyThemeScripts.variantsPickerCompose, GkifyThemeScripts.productInventory],
          'variants-picker',
          () => {
            const colorScheme = this.modalContent.dataset.colorScheme;
            this.modal.removeChild(this.modal.firstChild);
            this.modal.appendChild(this.modalContent);
            this.modal.setWidth('960px');
            this.modal.open();
            this.modal.setSizes(`g-gradient ${colorScheme}`);
            this.toggleLoading(this.target, false);
            this.isOpen = true;
            this.scrollToTop();
          }
        );
        if (firstModel) {
          loadAssetsNew(
            [
              GkifyThemeScripts.productModel,
              'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css',
            ],
            'product-model-assets'
          );
        }
      })
      .catch(console.error);
  }

  close(e) {
    this.modal.close(e);
    this.isOpen = false;
  }

  toggleLoading(target, loading) {
    if (loading) {
      target.classList.add('g-spinner-loading');
    } else {
      target.classList.remove('g-spinner-loading');
    }
  }
}

GkifyTheme.ProductQuickView = new QuickView();

function loadPaypalScript() {
  try {
    const script = document.createElement('script');
    script.src = `${
      window.location.origin
    }/cdn/shopifycloud/portable-wallets/latest/portable-wallets.en.js?v=${Date.now()}`;
    script.type = 'module';
    script.defer = true;
    document.body.appendChild(script);
  } catch (error) {
    console.error(error);
  }
}
